<ion-content [scrollEvents]="true">
  <div class="offline-delivery-container" *ngIf="delivery">
    <div class="view-content">
      <div class="loader image-loader"></div>
      <img [src]="getDeliveryImageUrl(delivery)"
           (error)="imgLoadedErr(delivery)"
           class="view-image">
    </div>

    <h2>{{delivery?.artistName}}</h2>
    <h3>{{delivery?.distributionName}}</h3>
    <p>This offline delivery has expired</p>

    <ion-button slot="center"
                (click)="onRemoveFileClick(delivery?.deliveryKeyCode)"
                color="medium"
                shape="round"
                class="offline-button">
      <span>Remove Expired File</span>
    </ion-button>
  </div>
</ion-content>
